/* eslint-disable react/jsx-fragments */
/** @jsxRuntime classic */
/** @jsx jsx */
import { LogError } from 'business/constants';
import BlockContent from 'components/blocks/block-content';
import PageLayout from 'components/ui-components/layout/PageLayout';
import SEO from 'components/utility-wrappers/seo';
import { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { Container, Heading, jsx, Text } from 'theme-ui';

export default function JobOpening() {
  const { slug } = useParams();
  const { data, error } = useSWR(
    `*[_type == 'jobopening' && slug.current == '${slug}']{
        _id,
        title,
        slug,
        publishedAt,
        body []{
          ...,
          _type == "employee" => {
            "employee": @->{...}
          },
          _type == "office_reference" => {
            "office": @->{...}
          },
        },
        seo,
      }[0]`,
    {},
  );

  if (error || !data) {
    if (error) {
      LogError(undefined, undefined, error);
    }
    return null;
  }

  const { publishedAt, title, body, seo = {} } = data || {};

  return (
    <Fragment>
      <SEO title={title} {...seo} />
      <PageLayout id={title || seo.title || 'JobOpening'}>
        <Container
          sx={{ width: 'auto', marginX: 'auto', maxWidth: '45ch' }}
          data-scroll-section
        >
          {publishedAt && (
            <Text variant="body">{publishedAt.replace(/-/g, '.')}</Text>
          )}
          <Heading
            as="h1"
            variant="h1"
            marginBottom={4}
            data-scroll
            data-scroll-repeat
          >
            {title}
          </Heading>
          {body && (
            <BlockContent
              blocks={body}
              data-scroll
              sx={{
                ul: {
                  marginBottom: '4rem',

                  li: {
                    fontSize: [3, null, null, 4],
                    marginBottom: '2rem',
                    paddingLeft: '3rem',
                    position: 'relative',

                    '&:before': {
                      content: '""',
                      width: '0.8rem',
                      height: '0.8rem',
                      borderRadius: '99px',
                      position: 'absolute',
                      left: 0,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      backgroundColor: 'text',
                    },
                  },
                },
              }}
            />
          )}
        </Container>
      </PageLayout>
    </Fragment>
  );
}
